import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { db } from '../../index';
import { collection, where, query, orderBy, limit, getDocs } from "firebase/firestore";
import Dream, { firestoreToDream } from '../../classes/Dream';


const initialState = {
  isLoading: false,
  dreams: [],
  lastVisibleDream: null,
  hasDreams: false,
  loadingHasDreams: false,
  hasLoadedHasDreams: false,
}

const dreamQueryBuilder = (uuid, lastVisible) => {
  // if(lastVisible) {
  //   return query(
  //     collection(db, "dreams"),
  //     where("authorId", "==", uuid),
  //     orderBy("createdAt", "desc"),
  //     startAfter(lastVisible),
  //     limit(100)
  //   )
  // } else {
    return query(
      collection(db, "dreams"),
      where("authorId", "==", uuid),
      orderBy("createdAt", "desc"),
      limit(100)
    )
  // }
}

export const fetchHasDream = createAsyncThunk(
    'dream/fetchHasDream',
    async (args) => {
        const { uuid } = args
        try {
            const q = query(
                collection(db, "dreams"),
                where("authorId", "==", uuid),
                limit(1)
            )
            const results = await getDocs(q)
            return !!results.size
        } catch(e) {
            console.error(">>> ERROR fetching has dream: ", e)
        }
    }
)

export const getDreamLog = createAsyncThunk(
  'dream/getDreamLog',
  async (args) => {
    const { uuid, lastVisible } = args;
    try {
      const q = dreamQueryBuilder(uuid, lastVisible)
      const results = await getDocs(q)

      //const lastVisibleDream = results.docs[results.docs.length-1]

      var dreamList = [];

      results.forEach(dream => {
        dreamList.push(firestoreToDream(dream).toJson())
      })


      return { dreamList }
    } catch (e) {
      console.error(">>> ERROR fetching dream log: ", e);
    }
  }
)

export const dreamLogSlice = createSlice({
  name: 'dreamLog',
  initialState,
  reducers: {
    resetLog: (state, action) => {
      state.dreams = [];
      state.lastVisibleDream = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDreamLog.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getDreamLog.fulfilled, appendDreams)
      .addCase(fetchHasDream.pending, (state) => {
          state.loadingHasDreams = true
      })
      .addCase(fetchHasDream.fulfilled, (state, action) => {
          state.loadingHasDreams = false
          state.hasLoadedHasDreams = true
          state.hasDreams = action.payload
      })
  }
})

const appendDreams = (state, action) => {
  state.isLoading = false;

  const { dreamList } = action.payload;
  //
  //state.lastVisibleDream = lastVisibleDream
  //
  // state.dreams = state.dreams.concat(dreamList);

  state.dreams = dreamList
}

export const { resetLog } = dreamLogSlice.actions;

export const getDreams = (state) => state.dreamLog.dreams.map(d => Dream.fromJson(d));

export const getIsLoading = (state) => state.dreamLog.isLoading;

export const getLastVisibleDream = (state) => state.dreamLog.lastVisibleDream;

export const getHasDreams = (state) => state.dreamLog.hasDreams
export const getLoadingHasDreams = (state) => state.dreamLog.loadingHasDreams
export const getHasLoadedHasDreams = (state) => state.dreamLog.hasLoadedHasDreams

export default dreamLogSlice.reducer;
